import { useCallback } from 'react';

import { Container, LeftSection, StickyPageHeaderSkeletonWithButtons } from '@/_containers';
import { SecondaryPageLayoutLoading } from '@/_containers/layout/secondary-page-layout';
import AdvertisementLoading from '@/_pages/settings/job-positions/advertisement/loading';
import AgreementLoading from '@/_pages/settings/job-positions/agreement/loading';
import HiringLoading from '@/_pages/settings/job-positions/hiring/loading';
import { subNav } from '@/_pages/settings/job-positions/model';
import ProfileLoading from '@/_pages/settings/job-positions/profile/loading';
import { useCurrentLocation } from '@/_shared';

export function TemplateLoading() {
  const { matched } = useCurrentLocation();
  const { tabKey } = matched?.staticData ?? {};

  const render = useCallback(() => {
    switch (tabKey) {
      case 'settings/job-position/advertisement':
        return <AdvertisementLoading />;
      case 'settings/job-position/agreement':
        return <AgreementLoading />;
      case 'settings/job-position/hiring':
        return <HiringLoading />;
      case 'settings/job-position/profile':
      default:
        return <ProfileLoading />;
    }
  }, [tabKey]);

  return (
    <SecondaryPageLayoutLoading subNavLinks={subNav}>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} allowBack />
      <Container>
        <LeftSection>{render()}</LeftSection>
      </Container>
    </SecondaryPageLayoutLoading>
  );
}
